const dataServicePage = [
  {
    pathName: "/coal-and-mineral-drilling-services-detail",
    datas: {
      id: 1,
      title: "Coal-And-Mineral-Drilling-Services-Detail",
      description:
        "GGS has developed various methods in drilling techniques, from touch coring drilling method to full coring drilling. These drilling methods are for testing the coal sources and other  mineral in a prospect area and will continue with drawing in lithological profile for every drill hole in the report format to the client. The total depth of the drill holes depend on the request and the needs of our clients and the presentation of the drill result (core recovery) will be inserted into core box and next on by our geologist will be analyzed and interpreted into type, character and structure of the rock in the prospect area.Drilling Machine that are used by GGS are Jack-Row 300, Jack-Row 200, Jack-Row 175, Jack-Row 150, Power Rig and Spindle Rig for Geotech Drill.",
      src: "/photos/services/Coal-and-Mineral-Drilling-Services.jpeg",
    },
  },
  {
    pathName: "/geotechnical-drilling-and-soil-investigation-detail",
    datas: {
      id: 2,
      title: "Geotechnical-Drilling-And-Soil-Investigation-Detail",
      description:
        "GGS also provided geotechnical drilling services and soil investigation such as Standard Penetration Test (SPT) and Cone Penetration Test (CPT).",
      src: "/photos/services/Geotechnical-Drilling-and-Soil-Investigation.jpeg",
    },
  },
  {
    pathName: "/surface-mapping-detail",
    datas: {
      id: 3,
      title: "Surface-Mapping-Detail",
      description:
        "The services that GGS can carry out are from topography mapping  survey, regional mapping/initial survey, semi-detail geological  mapping to detail geological mapping for exploitation of coal and other mineral (gold, nickel, etc.). General difference mapping techniques is the scale of the maps. The preliminary survey mapping activities for exploration include outcrops evaluation and the potential of coal/mineral in the surveyed area such as: rock type, coal type, mineralization type, the stretch of coal/mineral, the surroundings of sedimentation, location and geological condition and geological structure.",
      src: "/photos/services/Surface-Mapping.png",
    },
  },
];

export default dataServicePage;
